










































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import orderBy from 'lodash/orderBy'
import format from 'date-fns/format'

import Default from '../components/common/Default.vue'
import {
  ActionFetchAll,
  User,
  ActionUpdateRecommend,
  FirebaseDate,
  ActionDelete
} from '../store/user/types'
import LoadingModal from '../components/common/LoadingModal.vue'
import ConfirmModal from '../components/common/ConfirmModal.vue'
import NotificationAlert from '../components/common/NotificationAlert.vue'
import { downloadCSV } from '../lib/fileUtils'

const UserModule = namespace('user')
const MAX_DELETE_USERS = 15

type DisplayUser = {
  id: string
  name: string
  email: string
  recommended: boolean | null
  createdAt: string
}

@Component({
  components: { Default, LoadingModal, ConfirmModal, NotificationAlert }
})
export default class AdminUsers extends Vue {
  @UserModule.Action('fetchAll') fetchAll!: ActionFetchAll
  @UserModule.Action('updateRecommend')
  updateRecommend!: ActionUpdateRecommend
  @UserModule.Action('delete') delete!: ActionDelete
  headers = [
    { value: 'id', text: 'ID', sortable: false },
    { value: 'name', text: '名前', sortable: true },
    { value: 'email', text: 'メールアドレス', sortable: true },
    { value: 'createdAt', text: '登録日', sortable: true },
    { value: 'recommended', text: 'オススメ', sortable: true, width: 100 },
    { value: 'delete', text: '退会', sortable: false }
  ]
  users: User[] = []
  selected: DisplayUser[] = []
  search = ''
  loading = false
  loadingText = ''
  // 退会処理
  deleted = false
  error = false
  errorMessage = ''
  // ページング
  page = 1
  perPage = 15
  // 削除
  deleteMode: 'single' | 'selected' = 'single'
  deleteDialog = false
  deleteMessage = ''
  deleteUser: DisplayUser | null = null

  mounted() {
    this.fetchAllUsers()
  }

  get displayUsers(): DisplayUser[] {
    return this.users.map(u => ({
      id: u.id,
      name: u.familyName && u.firstName ? `${u.familyName} ${u.firstName}` : '',
      email: u.email,
      recommended: u.recommended,
      createdAt: format(
        (u.createdAt as FirebaseDate).toDate(),
        'yyyy/MM/dd HH:mm'
      )
    }))
  }

  get deleteConfirmMessage() {
    return this.deleteUser
      ? `${this.deleteUser.name}様の退会処理を行います。よろしいですか？`
      : ''
  }

  async fetchAllUsers() {
    this.loadingText = 'Loading...'
    this.loading = true
    return this.fetchAll()
      .then(users => {
        this.users = orderBy(
          users.filter(u => !u.admin),
          user => (user.createdAt as FirebaseDate).toDate()
        )
      })
      .finally(() => {
        this.loading = false
      })
  }

  async handleToggleRecommended(user: DisplayUser) {
    if (this.loading) return false
    this.loadingText = 'オススメ更新処理中です'
    this.loading = true
    await this.updateRecommend({
      userId: user.id,
      recommended: !user.recommended
    })
    this.users = this.users.map(u =>
      u.id === user.id ? { ...u, recommended: !user.recommended } : u
    )
    this.loading = false
  }

  handleDelete(user: DisplayUser) {
    this.deleteUser = user
    this.deleteMode = 'single'
    this.deleteMessage = this.deleteConfirmMessage
    this.deleteDialog = true
  }

  handleDeleteSelected() {
    if (this.selected.length > MAX_DELETE_USERS) {
      this.errorMessage = `一括退会は最大${MAX_DELETE_USERS}名まで可能です`
      this.error = true
      return
    }
    if (this.selected.length === 0) {
      this.errorMessage = `選択されたユーザがいません`
      this.error = true
      return
    }
    this.deleteMode = 'selected'
    this.deleteMessage =
      '選択されたユーザの一括退会処理を行います。よろしいですか？'
    this.deleteDialog = true
  }

  async handleDeleteAccept() {
    const userIds =
      this.deleteMode === 'single'
        ? this.deleteUser
          ? [this.deleteUser.id]
          : []
        : this.selected.map(u => u.id)
    this.loadingText = '退会処理中です'
    this.loading = true
    this.delete(userIds)
      .then(async () => {
        this.deleted = true
        this.selected = []
        await this.fetchAllUsers()
      })
      .catch(() => {
        this.errorMessage = '退会処理に失敗しました'
        this.error = true
      })
      .finally(() => {
        this.loading = false
        this.deleteDialog = false
      })
  }

  handleExport() {
    const data = [
      ['ID', '名前', 'メールアドレス', '登録日', 'オススメ'],
      ...this.users.map(u => [
        u.id,
        u.familyName && u.firstName ? `${u.familyName} ${u.firstName}` : '',
        u.email,
        format((u.createdAt as FirebaseDate).toDate(), 'yyyy/MM/dd HH:mm'),
        u.recommended ? '◯' : ''
      ])
    ]
    downloadCSV(data)
  }
}
